module.exports = __webpack_public_path__ + "img/2019110804.0d815957.jpg";